module.exports = __webpack_public_path__ + "img/电话警告.a816c540.jpg";